// ======================================================
// Updated by: Halimunnisa
// Feature: Customer Acceptance Workflow
// Purpose: Exports the CustomerAcceptanceScreen as the default module entry.
// ======================================================
import CustomerAcceptanceScreen from './screens/CustomerAcceptanceScreen';

export default CustomerAcceptanceScreen;
